import { URLS } from 'api/constants';
import { IBlogPost, IBlogPostType } from 'constants/types';
import { apiGet, apiGetSafe } from './client';
import { PaginationResponse } from './types';

export async function getBlogPostById(id?: string) {
  return apiGetSafe<IBlogPost>(`${URLS.BLOG_POSTS}/${id ?? ''}`);
}

export async function listBlogPosts({
  type,
  category,
  limit,
  isTop,
}: {
  category?: string;
  limit?: number;
  isTop?: boolean;
  type?: IBlogPostType | undefined;
} = {}) {
  try {
    return await apiGet<PaginationResponse<IBlogPost>>(URLS.BLOG_POSTS, {
      type,
      category,
      limit,
      isTop,
    });
  } catch {
    return { results: [], count: 0 };
  }
}
